import { Injectable } from '@angular/core';
import { Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { DataIdName } from '../entities/global/model';
import { ComponentRepairData, CrackStatusesVM, CrackStausUpdateVM } from '../entities/component/model';
import { InspectedImplementsViewModel } from '../inspections/inspection.model';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Injectable()
export class GETInventoryService {

    private newRepairerId: number = 0;
    private newWorkshopId: number = 0;

    constructor(private _http: HttpClient, private datePipe: DatePipe) {

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public setRepairerId(Id: number): void{
        this.newRepairerId = Id;
    }

    public getRepairerId(): number {
        return this.newRepairerId;
    }

    public setWorkshopId(Id: number): void {
        this.newWorkshopId = Id;
    }

    public getWorkshopId(): number {
        return this.newWorkshopId;
    }

    // public returnInventoryStatusList(): Observable<DataIdName[]> {
    //     return this._http.get("Api/GETInventory/ReturnInventoryStatusList").share().map(
    //         (response: Response) => <DataIdName[]>response.json()).catch(this.handleError);
    // }
    // public returnRepairerListForCustomer(id: number): Observable<DataIdName[]> {
    //     let options = {
    //         params: new HttpParams().set('Id', id.toString())
    //     };
    //     return this._http.get("Api/GETInventory/ReturnRepairerListForCustomer", options).share().map(
    //         (response: Response) => <DataIdName[]>response.json()).catch(this.handleError);
    // }
    // public returnWorkshopListForRepairer(id: number): Observable<DataIdName[]> {
    //     let options = {
    //         params: new HttpParams().set('Id', id.toString())
    //     };
    //     return this._http.get("Api/GETInventory/ReturnWorkshopListForRepairer", options).share().map(
    //         (response: Response) => <DataIdName[]>response.json()).catch(this.handleError);
    // }
    // public checkIfRepairerRequiredForStatus(status: number): Observable<boolean> {
    //     let options = {
    //         params: new HttpParams().set('status', status.toString())
    //     };
    //     return this._http.get("Api/GETInventory/CheckIfRepairerRequired", options).share().map(
    //         (response: Response) => <boolean>response.json()).catch(this.handleError);
    // }

public returnInventoryStatusList(): Observable<DataIdName[]> {
  return this._http.get<DataIdName[]>("Api/GETInventory/ReturnInventoryStatusList")
      .pipe(
          shareReplay(),
          map((response: DataIdName[]) => response),
          catchError(this.handleError)
      );
}

public returnRepairerListForCustomer(id: number): Observable<DataIdName[]> {
  let options = {
      params: new HttpParams().set('Id', id.toString())
  };
  return this._http.get<DataIdName[]>("Api/GETInventory/ReturnRepairerListForCustomer", options)
      .pipe(
          shareReplay(),
          map((response: DataIdName[]) => response),
          catchError(this.handleError)
      );
}

public returnWorkshopListForRepairer(id: number): Observable<DataIdName[]> {
  let options = {
      params: new HttpParams().set('Id', id.toString())
  };
  return this._http.get<DataIdName[]>("Api/GETInventory/ReturnWorkshopListForRepairer", options)
      .pipe(
          shareReplay(),
          map((response: DataIdName[]) => response),
          catchError(this.handleError)
      );
}

public checkIfRepairerRequiredForStatus(status: number): Observable<boolean> {
  let options = {
      params: new HttpParams().set('status', status.toString())
  };
  return this._http.get<boolean>("Api/GETInventory/CheckIfRepairerRequired", options)
      .pipe(
          shareReplay(),
          map((response: boolean) => response),
          catchError(this.handleError)
      );
}
    // public createRepairer(jobsiteId: number, repairerName: string): Observable<number> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     params.set('jobsiteId', jobsiteId.toString());
    //     params.set('name', repairerName);
    //     let options = {
    //         params: new HttpParams().set('jobsiteId', jobsiteId.toString())
    //             .set('name', repairerName)
    //     };
    //     return this._http.get("Api/GETInventory/CreateRepairer", options).share().map(
    //         (response: Response) => <number>response.json()).catch(this.handleError);
    // }
    // public createWorkshop(repairerId: number, workshopName: string): Observable<number> {
    //     let options = {
    //         params: new HttpParams().set('repairerId', repairerId.toString())
    //             .set('name', workshopName)
    //     };
    //     return this._http.get("Api/GETInventory/CreateWorkshop", options).share().map(
    //         (response: Response) => <number>response.json()).catch(this.handleError);
    // }

public createRepairer(jobsiteId: number, repairerName: string): Observable<number> {
  let options = {
      params: new HttpParams()
          .set('jobsiteId', jobsiteId.toString())
          .set('name', repairerName)
  };
  
  return this._http.get<number>("Api/GETInventory/CreateRepairer", options)
      .pipe(
          shareReplay(),
          map((response: number) => response),
          catchError(this.handleError)
      );
}

public createWorkshop(repairerId: number, workshopName: string): Observable<number> {
  let options = {
      params: new HttpParams()
          .set('repairerId', repairerId.toString())
          .set('name', workshopName)
  };
  
  return this._http.get<number>("Api/GETInventory/CreateWorkshop", options)
      .pipe(
          shareReplay(),
          map((response: number) => response),
          catchError(this.handleError)
      );
}

    public getCrackStatusId(GETObservationPointId: number): Observable<number> {
        // Create HttpParams
        let params = new HttpParams().set('GETObservationPointId', GETObservationPointId.toString());
    
        return this._http.get<number>("Api/GETComponent/GetCrackStatusId", { params })
          .pipe(
            map((response: number) => response),
            catchError(this.handleError)
          );
      }
    
      public getCrackStatuses(): Observable<CrackStatusesVM[]> {
        return this._http.get<CrackStatusesVM[]>("Api/GETComponent/GetCrackStatuses")
          .pipe(
            map((response: CrackStatusesVM[]) => response),
            catchError(this.handleError)
          );
      }
  public CrackStatusUpdate(data: CrackStausUpdateVM): Observable<boolean> {
    // Create HttpParams
    let params = new HttpParams()
      .set('obsId', data.obsId.toString())
      .set('status', data.status.toString())
      .set('date', data.date.toDateString())
      .set('comment', data.comment.toString())
      .set('smu', data.smu.toString())
      .set('cost', data.cost.toString())
      .set('statusId', data.statusId.toString());

    return this._http.get<boolean>("Api/GETComponent/UpdateCrackStatus", { params })
      .pipe(
        map((response: boolean) => response),
        catchError(this.handleError)
      );
  }

    public repairComponent(data: ComponentRepairData): Observable<boolean> {
        // Create HttpParams
        let params = new HttpParams()
          .set('componentId', data.componentId.toString())
          .set('cost', data.cost.toString())
          .set('date', data.date.toDateString())
          .set('comment', data.comment.toString())
          .set('Smu', data.smu.toString())
          .set('labourHrs', data.labourHrs.toString())
          .set('labourCost', data.labourCost.toString())
          .set('parts', data.parts.toString())
          .set('misc', data.misc.toString())
          .set('Planned', data.planned.toString())
          .set('equipmentId', data.equipmentId?.toString())
          .set('DateUTC', data.DateUTC);
        return this._http.get<boolean>("Api/GETComponent/PerformRepair", { params })
          .pipe(
            map((response: boolean) => response),
            catchError(this.handleError)
          );
      }
  public repairComponentAssetRepair(data: ComponentRepairData): Observable<boolean> {
    // Create HttpParams
    let params = new HttpParams()
      .set('componentId', data.componentId.toString())
      .set('cost', data.cost.toString())
      .set('date', data.date.toDateString())
      .set('comment', data.comment.toString())
      .set('Smu', data.smu.toString())
      .set('labourHrs', data.labourHrs.toString())
      .set('labourCost', data.labourCost.toString())
      .set('parts', data.parts.toString())
      .set('misc', data.misc.toString());

    return this._http.get<boolean>("Api/GETComponent/PerformRepairAssetRepair", { params })
      .pipe(
        map((response: boolean) => response),
        catchError(this.handleError)
      );
  }

    // public replaceComponent(data: ComponentRepairData): Observable<boolean> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     params.set('componentId', data.componentId.toString());
    //     params.set('cost', data.cost.toString());
    //     params.set('date', data.date.toDateString());
    //     params.set('comment', data.comment.toString());
    //     params.set('Smu', data.smu.toString());
    //     params.set('downTimeHrs', data.downTimeHrs.toString());
    //     params.set('labourHrs', data.labourHrs.toString());
    //     params.set('labourCost', data.labourCost.toString());
    //     params.set('parts', data.parts.toString());
    //     params.set('misc', data.misc.toString());
    //     return this._http.get("Api/GETComponent/PerformReplace", { search: params }).share().map(
    //         (response: Response) => <boolean>response.json()).catch(this.handleError);
    // }


  public replaceComponent(data: ComponentRepairData): Observable<boolean> {
    // Create HttpParams
    let params = new HttpParams()
      .set('componentId', data.componentId.toString())
      .set('cost', data.cost.toString())
      .set('date', data.date.toDateString())
      .set('comment', data.comment.toString())
      .set('Smu', data.smu.toString())
      .set('downTimeHrs', data.downTimeHrs.toString())
      .set('labourHrs', data.labourHrs.toString())
      .set('labourCost', data.labourCost.toString())
      .set('parts', data.parts.toString())
      .set('misc', data.misc.toString())
      .set('Planned', data.planned.toString())
      .set('equipmentId', data.equipmentId?.toString())
      .set('DateUTC', data.DateUTC);

    return this._http.get<boolean>("Api/GETComponent/PerformReplace", { params })
      .pipe(
        map((response: boolean) => response),
        catchError(this.handleError)
      );
  }

    // public returnMinDateForComponentRepair(data: string): Observable<string> {
    //     let options = {
    //         params: new HttpParams().set('componentId', data.toString())
    //     };
    //     return this._http.get("Api/GETComponent/returnMinDateForRepair", options).share().map(
    //         (response: Response) => <string>response.json()).catch(this.handleError);
    // }

    // public returnMinDateForComponentReplace(data: string): Observable<string> {
    //     let options = {
    //         params: new HttpParams().set('componentId', data.toString())
    //     };
    //     return this._http.get("Api/GETComponent/returnMinDateForReplace", options).share().map(
    //         (response: Response) => <string>response.json()).catch(this.handleError);
    // }

    // public returnMinDateForImplementEvent(data: string): Observable<string> {
    //     let options = {
    //         params: new HttpParams().set('implementId', data.toString())
    //     };
    //     return this._http.get("Api/Implement/returnMinDateForImplementEvent", options).share().map(
    //         (response: Response) => <string>response.json()).catch(this.handleError);
    // }

    // public returnMinDateForImplement(ImplementId: number,InspectionId:number): Observable<string> {
    //     let options = {
    //         params: new HttpParams().set('ImplementId', ImplementId.toString())
    //         .set('InspectionId', InspectionId.toString())
    //     };
    //     return this._http.get("Api/Implement/returnMinDateForImplement", options).share().map(
    //         (response: Response) => <string>response.json()).catch(this.handleError);
    // }

    // public returnMaxDateForImplement(ImplementId: number,InspectionId:number): Observable<string> {
    //     let options = {
    //         params: new HttpParams().set('ImplementId', ImplementId.toString())
    //         .set('InspectionId', InspectionId.toString())
    //     };
    //     return this._http.get("Api/Implement/returnMaxDateForImplement", options).share().map(
    //         (response: Response) => <string>response.json()).catch(this.handleError);
    // }

   
public returnMinDateForComponentRepair(data: string): Observable<string> {
  let options = {
      params: new HttpParams().set('componentId', data.toString())
  };
  return this._http.get<string>("Api/GETComponent/returnMinDateForRepair", options)
      .pipe(
          shareReplay(),
          map((response: string) => response),
          catchError(this.handleError)
      );
}

public returnMinDateForComponentReplace(data: string): Observable<string> {
  let options = {
      params: new HttpParams().set('componentId', data.toString())
  };
  return this._http.get<string>("Api/GETComponent/returnMinDateForReplace", options)
      .pipe(
          shareReplay(),
          map((response: string) => response),
          catchError(this.handleError)
      );
}

public returnMinDateForImplementEvent(data: string): Observable<string> {
  let options = {
      params: new HttpParams().set('implementId', data.toString())
  };
  return this._http.get<string>("Api/Implement/returnMinDateForImplementEvent", options)
      .pipe(
          shareReplay(),
          map((response: string) => response),
          catchError(this.handleError)
      );
}

public returnMinDateForImplement(ImplementId: number, InspectionId: number): Observable<string> {
  let options = {
      params: new HttpParams().set('ImplementId', ImplementId.toString())
          .set('InspectionId', InspectionId.toString())
  };
  return this._http.get<string>("Api/Implement/returnMinDateForImplement", options)
      .pipe(
          shareReplay(),
          map((response: string) => response),
          catchError(this.handleError)
      );
}

public returnMaxDateForImplement(ImplementId: number, InspectionId: number): Observable<string> {
  let options = {
      params: new HttpParams().set('ImplementId', ImplementId.toString())
          .set('InspectionId', InspectionId.toString())
  };
  return this._http.get<string>("Api/Implement/returnMaxDateForImplement", options)
      .pipe(
          shareReplay(),
          map((response: string) => response),
          catchError(this.handleError)
      );
}

    // public UpdateGETInspectionDate(newInspectionModel: InspectedImplementsViewModel):Observable<number> {
    //     //newInspectionModel.InspectionStringDate = newInspectionModel.InspectionDate.toLocaleDateString('en-US');
    //     newInspectionModel.InspectionStringDate = this.datePipe.transform(newInspectionModel.InspectionDate, 'MM/dd/yyyy');
    //     return this._http.post('api/Implement/UpdateGETInspectionDate', newInspectionModel)
    //       .pipe(catchError(this.handleError));
    //   }
    
  public UpdateGETInspectionDate(newInspectionModel: InspectedImplementsViewModel): Observable<number> {
    // Format the date using datePipe
    newInspectionModel.InspectionStringDate = this.datePipe.transform(newInspectionModel.InspectionDate, 'MM/dd/yyyy');
    
    return this._http.post<number>('api/Implement/UpdateGETInspectionDate', newInspectionModel)
      .pipe(catchError(this.handleError));
  }
      public UpdateGETInspectionSMU(newInspectionModel: InspectedImplementsViewModel):Observable<any> {
        return this._http.post('api/Implement/UpdateGETInspectionSMU', newInspectionModel)
          .pipe(catchError(this.handleError));
      }
    //   public returnMinMaxSMUForImplement(ImplementId: number,InspectionId:number): Observable<number[]> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     params.set('ImplementId', ImplementId.toString());
    //     params.set('InspectionId', InspectionId.toString());

    //     return this._http.get("Api/Implement/returnMinMaxSMUForImplement", { search: params }).share().map(
    //         (response: Response) => <string>response.json()).catch(this.handleError);
    // }

  public returnMinMaxSMUForImplement(ImplementId: number, InspectionId: number): Observable<number[]> {
    // Create HttpParams
    let params = new HttpParams()
      .set('ImplementId', ImplementId.toString())
      .set('InspectionId', InspectionId.toString());

    return this._http.get<number[]>("Api/Implement/returnMinMaxSMUForImplement", { params })
      .pipe(
        map((response: number[]) => response),
        catchError(this.handleError)
      );
  }

    // public UpdateInventoryStatusEquipmentForGET(implementId:number,InventoryStatus:number): Observable<number> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     params.set('get_auto', implementId.toString());
    //     params.set('inventoryStatus', InventoryStatus.toString());
    //     return this._http.get("Api/Implement/UpdateInventoryStatusEquipmentForGET",{search: params}).share().map(
    //         (response: Response) => <DataIdName[]>response.json()).catch(this.handleError);
    // }

  public UpdateInventoryStatusEquipmentForGET(implementId: number, InventoryStatus: number): Observable<DataIdName[]> {
    // Create HttpParams
    let params = new HttpParams()
      .set('get_auto', implementId.toString())
      .set('inventoryStatus', InventoryStatus.toString());

    return this._http.get<DataIdName[]>("Api/Implement/UpdateInventoryStatusEquipmentForGET", { params })
      .pipe(
        map((response: DataIdName[]) => response),
        catchError(this.handleError)
      );
  }

}
